import $api from "@/frontend/shared/api/axios";

type TFounderRevisionData = {
  name?: string;
  description?: string;
  logoUrl?: string;
  city?: string;
  country?: string;
  state?: string;
  headline?: string;
  marketDescription?: string;
  solutionDescription?: string;
};

export async function postGenerateRevisionData({ data }: { data: TFounderRevisionData }) {
  const res = await $api.post(`/founder-revisions/create-new-revision`, data);
  return res.data.data;
}
